/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  AppConfig,
  AuthOptionAppearance,
  AuthOptionType,
  RouteHelper as CommonRouteHelper,
  IApplicationHeaderScreenModel,
  ScreenType,
  useScreenConfiguration,
} from "@bms/common";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../DesignSystem/Button";

import "./HeaderSignIn.scss";

export const HeaderSignIn = () => {
  const { t } = useTranslation();

  const screen = useScreenConfiguration<IApplicationHeaderScreenModel>(
    ScreenType.ApplicationHeader,
  );

  const {
    AuthOptionAppearance: optionAppearance = AuthOptionAppearance.Default,
    AuthOptionType: optionType = AuthOptionType.Default,
  } = screen;

  if (AppConfig.IsLoginDisabled) {
    return null;
  }

  if (optionType === AuthOptionType.None) {
    return null;
  }

  return (
    <div className="HeaderSignIn">
      <Button
        variant={
          optionAppearance === AuthOptionAppearance.Button ? "primary" : "link"
        }
        onClick={() => CommonRouteHelper.goToLogin()}
        className="HeaderSignIn__Button"
      >
        {t("COMMON__SIGN_IN")}
      </Button>
    </div>
  );
};
